import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module14World.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from './Practice';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule9 from '../../FollowTheBeat/FollowTheBeatModule9.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';

const Module14World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);

  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module14 } = useSelector((state) => state.module14, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module14Images/Background14-01.png');
  const background2 = generateImageUrl('images/Module14Images/landscape_without_trees.png');
  const monkeyStill = generateImageUrl('images/Module4Images/Monkey+Practice+still.gif');
  const progressbar0 = generateImageUrl('images/Module4Images/ProgressBanana0.png');
  const progressbar1 = generateImageUrl('images/Module4Images/ProgressBanana1.png');
  const progressbar2 = generateImageUrl('images/Module4Images/ProgressBanana2.png');
  const progressbar3 = generateImageUrl('images/Module4Images/ProgressBanana2.png');
  const progressbarCompleted = generateImageUrl('images/Module4Images/Reward_Banana.png');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module4Images/Reward_Banana.png');
  const Elephants = generateImageUrl('images/Module4Images/Reward_Elephant.png');
  const Zebras = generateImageUrl('images/Module4Images/Reward_Zebras.png');
  const Yeti = generateImageUrl('images/Module9Images/DailyReward_Yeti.png');
  const YetiBrown = generateImageUrl('images/Module9Images/DailyReward_Yeti_Brown.png');
  const JeepBlue = generateImageUrl('images/Module4Images/Reward_Car2.png');
  const JeepPink = generateImageUrl('images/Module4Images/Reward_Car.png');
  const Dragon = generateImageUrl('images/Module9Images/DailyReward_Dragon.png');
  const Pheonix = generateImageUrl('images/Module9Images/DailyReward_Pheonix.png');
  const Parrot = generateImageUrl('images/Module4Images/Reward_BirdColors.png');
  const Tucan = generateImageUrl('images/Module4Images/Reward_Tucan.png');
  const Horse1 = generateImageUrl('images/Module14Images/UnicornBlue.png');
  const Horse2 = generateImageUrl('images/Module14Images/UnicornPink.png');
  const Lion = generateImageUrl('images/Module4Images/Reward_Lion.png');
  const Cheetah = generateImageUrl('images/Module4Images/Reward_Cheetah.png');
  const Hat1 = generateImageUrl('images/Module9Images/DailyReward_Hat1.png');
  const Hat2 = generateImageUrl('images/Module9Images/DailyReward_Hat2.png');
  const MedievalCastle = generateImageUrl('images/Module9Images/BigReward_Castle.png');
  const StoneSword = generateImageUrl('images/Module9Images/BigReward_StoneSword.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'e7c7451cb8697cffc1a737a5de25/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');
  const [animal, setAnimal] = useState(monkeyStill);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [keyAnimationState, setKeyAnimationState] = useState('bounceIcons');
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [monkeyEat, setMonkeyEat] = useState(false);
  const [monkeyEatAudio, setMonkeyEatAudio] = useState(false);
  const [specialMessage, setSpecialMessage] = useState(false);
  const [watchConversation, setWatchConversation] = useState(false);
  const [practiceIntro, setPracticeIntro] = useState('');
  const [practiceIntroAudio, setPracticeIntroAudio] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [animalClose, setAnimalClose] = useState(false);
  const [playAnimalClose, setPlayAnimalClose] = useState(false);
  const [animalCloseAudio, setAnimalCloseAudio] = useState(false);
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [amazingJob, setAmazingJob] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'))

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const playButtonAudio = useCallback(() => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  }, []);

  function getGifs() {
    setMonkeyEat(getVideo('appfiles/posture/monkey_banana.gif', login));
    setMonkeyEatAudio(getVideo('appfiles/posture/monkey_eating.mp3', login));
    setSpecialMessage(getVideo('appfiles/respond/respond_special_message.gif', login));
    setWatchConversation(getVideo('appfiles/respond/respond_watch_conversation.gif', login));
    setAmazingJob(getVideo('appfiles/respond/respond_amazing_job.gif', login));
    setPracticeIntro(getVideo('appfiles/respond/respond_practice_intro.gif', login));
    setLearnIntro(getVideo('appfiles/respond/respond_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/respond/respond_ftb_intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/respond/respond_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/respond/respond_day_finished.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/solutions/solutions_day_finished.mp3', login));
    setFTBInstruction(getVideo('appfiles/solutions/solutions_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/respond/respond_ftb_instructions.gif', login));
    setFTBMusic(getVideo('appfiles/respond/respond_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/respond/countingMonkey.gif', login));

    if (!module14.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));
      setFTBTutorial2(getVideo('appfiles/solutions/ftb_walkthrough_tap.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/respond/ftb_walkthrough_audio.mp3', login));
    }

  }

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module14.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.psuh(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module14.rewards) {
          if (module14.rewards[key].unlocked === true) {
            const rewards = {
              type: key,
              x_multiplier: module14.rewards[key].x,
              y_multiplier: module14.rewards[key].y,
            };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE14_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module14.game_details, module14.rewards]
  );

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "Solutions",
				day_completed: module14.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = useCallback(async () => {
    const myInit = {
      body: {
        id: module14.moduleID,
        day_completed: module14.day_completed,
        step_completed: module14.stepCompleted,
        game_details: JSON.stringify(module14.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayAnimalClose(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch(() => {
        if (
          module14.stepCompleted === 'notstarted' ||
          module14.stepCompleted === 'learn' ||
          module14.stepCompleted === 'practice' ||
          module14.stepCompleted === 'celebrate' ||
          module14.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'Solutions',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  });

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module14.stepCompleted]);

    useEffect(() => {
      if((module14.reviewIcon === true || login.grade === "Teacher Mode") && module14.sectionCompleted === 4 ) {
          updateProgress();
          module14.sectionCompleted = 0;
      }
    }, [module14.sectionCompleted])

  useEffect(() => {
    if (module14.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module14.coins);
      updateDB();
    }
  }, [module14.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module14.currentday <= module14.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE14_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE14_SET_KEY', payload: 4 });
      if (module14.currentday === 4 || module14.currentday === 8) {
        dispatch({ type: 'MODULE14_SET_KEY', payload: 5 });
      }
    } else {
      if (module14.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE14_TOGGLE_REVIEW_ICON', payload: false });
      if (module14.currentday === 4 && module14.day_completed === 3) {
        if (module14.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 0 });

        } else if (module14.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 1 });

        } else if (module14.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 2 });

        } else if (module14.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 3 });

        } else if (module14.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 4 });

        } else if (module14.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE14_SET_KEY', payload: 5 });
          
        }
        playButtonAudio();
      } else {
        if (module14.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 0 });

        } else if (module14.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 1 });
   
        } else if (module14.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 2 });
 
        } else if (module14.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 3 });

        } else if (module14.stepCompleted === 'celebrate') {
          if (module14.currentday === 8 && module14.day_completed === 7) {
            dispatch({ type: 'MODULE14_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE14_SET_KEY', payload: 4 });
          }
        } else if (module14.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE14_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [ module14.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);

  const selectReward = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE14_SET_REWARD${module14.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE14_SET_REWARD${module14.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE14_SET_REWARD${module14.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE14_SET_REWARD${module14.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;            
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
            <div id="dropZone">
              <div id ='word'>Drag and drop your item</div>
            </div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE14_SET_DAY_UNLOCK${module14.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE14_SET_dayCompleted',
                    payload: module14.currentday === 8 ? 9 : module14.currentday,
                  });
                  dispatch({
                    type: 'MODULE14_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={MedievalCastle}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE14_SET_PRIZE1', payload: true });
                dispatch({ type: 'MODULE14_SET_PRIZE2', payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={StoneSword}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE14_SET_PRIZE2', payload: true });
                dispatch({ type: 'MODULE14_SET_PRIZE1', payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
            <div id="dropZone">
              <div id ='word'>Drag and drop your item</div>
            </div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setDisplayPrize(false);
                setCheckSound(true);
                setDropZone(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE14_SET_COIN',
                    payload: module14.coins - 100,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module14.currentday) {
      case 1:
        setRewardOption1(Elephants);
        setRewardOption2(Zebras);
        break;
      case 2:
        setRewardOption1(Yeti);
        setRewardOption2(YetiBrown);
        break;
      case 3:
        setRewardOption1(JeepBlue);
        setRewardOption2(JeepPink);
        break;
      case 4:
        setRewardOption1(Dragon);
        setRewardOption2(Pheonix);
        break;
      case 5:
        setRewardOption1(Tucan);
        setRewardOption2(Parrot);
        break;
      case 6:
        setRewardOption1(Horse1);
        setRewardOption2(Horse2);
        break;
      case 7:
        setRewardOption1(Lion);
        setRewardOption2(Cheetah);
        break;
      case 8:
        setRewardOption1(Hat1);
        setRewardOption2(Hat2);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [
    keyIcon,
    Cheetah,
    Dragon,
    Elephants,
    Hat1,
    Hat2,
    Horse1,
    Horse2,
    JeepBlue,
    JeepPink,
    Lion,
    Parrot,
    Pheonix,
    Tucan,
    Yeti,
    YetiBrown,
    Zebras,
    module14.currentday,
  ]);

  const displayReview = () => {
    if (module14.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/solutions/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module14.currentday === 4) {
              dispatch({ type: 'MODULE14_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module14.day_completed === 9) {
              navigate('/solutions/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/solutions/solutions_demo.m4a', login);
    let video = getVideo('appfiles/solutions/learn_video.mp4', login);
    switch (module14.currentday) {
      case 1:
        setLearn(
          <Learn
            video='f95f4713772eb9433c9bf1f05cd9/480.m3u8'
            songVideo={video}
            closingVideo='5adaaaf04c1a432b81ed3507e843/learn_day1_part2.mp4'
            destiny='/solutions'
            song={song}
            back='/solutions'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE14_SET_stepCompleted'
            module={module14}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='a186a2f6a7911f2f75bd8125ac89/480.m3u8'
            songVideo={video}
            closingVideo='64a0310420acb14c47cd9dab210d/480.m3u8'
            destiny='/solutions'
            song={song}
            back='/solutions'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE14_SET_stepCompleted'
            module={module14}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='84a4aebf4800c8214ccf380759e4/480.m3u8'
            songVideo={video}
            closingVideo='ce4c5ecc5542394185944c6baa11/learn_day3_part2.mp4'
            destiny='/solutions'
            song={song}
            back='/solutions'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE14_SET_stepCompleted'
            module={module14}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/solutions/solutions_learn_intro.mp3', login));
        // // setDisplayVoice(true);
        // setAnimalState(learnIntro);
        // setShowAnimal(true);
        await GetUserVideo(`userfiles/${module14.StudentID}/solutions_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module14.currentday - 4]}/respond_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/solutions'
                    song={data}
                    back='/solutions'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE14_SET_stepCompleted'
                    module={module14}
                    instrumental={getVideo('appfiles/solutions/solutions_mix.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              }else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/solutions'
                    song={song}
                    back='/solutions'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE14_SET_stepCompleted'
                    module={module14}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
 
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    // switch (module14.currentday) {
    //   case 1:
    //     break;
    //   case 2:
    //     break;
    //   case 3:
    //     break;

    //   default:
    //     setDisplayFTB(true);
    //     setAnimalVoice(getVideo('appfiles/respond/respond_ftb_intro.mp3', login));
    //     // setDisplayVoice(true);
    //     setAnimalState(ftbIntro);
    //     setShowAnimal(true);
    //     break;
    // }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = '91a2b6aa52546f7215cac28ed603/480.m3u8';
    const celebrateVideo2 = '9f9ca2d4a8e0ebc61d7666d86188/480.m3u8';
    const celebrateVideo3 = 'fb738835c4695984702a34be255d/480.m3u8';

    switch (module14.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module14}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE14'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module14}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE14'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module14}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE14'}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/respond/respond_celebrate_intro.mp3', login));
        // // setDisplayVoice(true);
        // setAnimalState(celebrateIntro);
        // setShowAnimal(true);
        let voice1 = getVideo('appfiles/respond/respond_celebrate_record_do_all.mp3', login);
        let voice2 = getVideo('appfiles/respond/respond_celebrate_say_yes.mp3', login);
        let voice3 = getVideo('appfiles/respond/respond_amazing_job.mp3', login);
        let animalGIF = getVideo('appfiles/solutions/joyful monkey.gif', login);
        let animalVoice = getVideo('appfiles/solutions/monkey_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module14.currentday - 4]}/respond_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module14}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={
                'Record yourself in an excited voice and say, "I can do it all!"'
              }
              name={`solutions_celebration_surprise_${
                module14.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJob}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE14'}
              bigAnimal={true}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = 'fe7976c4c5317245745e7a897772/480.m3u8';
    let noteVideo = getVideo('appfiles/solutions/solutions_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/solutions/solutions_demo.m4a', login);
    let instrumental = getVideo('appfiles/solutions/solutions_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module14}
        moduleNum='MODULE14'
        name='solutions'
        instrumental={instrumental}
        instrumentalURL={'appfiles/solutions/solutions_mix.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/respond_affirmation.mp4`,
      },
      {
        video: `userfiles/${module14.StudentID}/solutions_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/respond_affirmation.mp4`,
      },
      {
        video: `userfiles/${module14.StudentID}/solutions_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/respond_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/respond_affirmation.mp4`,
      },
      {
        video: `userfiles/${module14.StudentID}/solutions_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/respond_affirmation.mp4`,
      },
    ];
    
    // Use a loop to simplify the repetitive code
    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
    
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/solutions/solutions_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const rewardAnimation = () => {
    setKeyAnimationState('fade-out');
    sleep(1000).then(() => {
      setKeyIcon(false);
      setAnimalVoice(monkeyEatAudio);
      // setDisplayVoice(true);
      setAnimalState(monkeyEat);
      setShowAnimal(true);
      sleep(3000).then(() => {
        setRewardsFound(true);
        setDisplayReward(true);
      });
    });
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE14_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE14_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  return (
    <>
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE14_SET_COIN',
              payload: module14.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {playAnimalClose && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayAnimalClose(false);
            module14.currentday === 8
              ? closeDay9Video()
              : navigate('/solutions/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
            document.getElementById('stillMonkey').style.display = 'none';
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setAnimalState('');
            setShowAnimal(false);
            setAnimal(monkeyStill);
            document.getElementById('stillMonkey').style.display = 'block';
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {displayPractice && (
        <Practice
          setDisplayPractice={setDisplayPractice}
          background={background}
          stepComplete={'MODULE14_SET_stepCompleted'}
          module={module14}
          watchConversation={watchConversation}
          specialMessage={specialMessage}
          amazingJob={amazingJob}
          animal={animal}
        />
      )}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule9
          unit3={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJob}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE14_SET_stepCompleted'}
          module={module14}
          score={'ftb_solutions'}
        />
      )}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySingingTime && singTime}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='respondWorldBody'
          style={{ backgroundImage: `url(${background2})` }}
        >
          <img className='respondWorldTree' src={generateImageUrl('images/Module14Images/U3m4.png')} alt='trre' />
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                navigate('/solutions/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
            content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}
          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                sleep(1400).then(() => {
                  sleep(1000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='monkey9' id='stillMonkey' src={animal} alt='monkey Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              className='monkey9'
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              alt='monkey Icon'
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
              
            />
            {module14.coins < 10 && (
              <h5 className='scoretext1'>{module14.coins}</h5>
            )}
            {module14.coins >= 10 && module14.coins < 100 && (
              <h5 className='scoretext10'>{module14.coins}</h5>
            )}
            {module14.coins >= 100 && (
              <h5 className='scoretext100'>{module14.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module14.currentday === 4 || module14.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey4'
                src={keys5[module14.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module14.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey4'
                src={keys4[module14.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module14.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module14.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module14.currentday === 4 &&
                  module14.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module14.currentday !== 4 &&
                  module14.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module14.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={practiceBtn}
                    alt='practice button'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}

                {module14.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={ftbBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}

                {module14.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={celebrateBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}

                {module14.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module14.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
              (<div className='actionBtnDiv'>
                {module14.reviewIcon &&
                (<img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                />)}
                {showReward && (
                  <img
                    src={rewardBtn}
                    className='actionBtn4'
                    alt='review button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        rewardAnimation();
                      });
                    }}
                />)}
                {module14.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon &&
            keyIcon &&
            !disPlayPrize &&
            module14.reviewIcon === false && (
              <img
                id={keyAnimationState}
                className='keyRewards'
                style={{
                  width: '150px',
                  height: '50px',
                  marginLeft: '-75px',
                  zIndex: 100,
                }}
                src={keyReward}
                alt='reward key'
                onClick={() => {
                  rewardAnimation();
                }}
              />
            )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module14.rewards.Elephants.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Elephants.x * clientWidth,
                  y: module14.rewards.Elephants.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveElephants17'
                  style={{ backgroundImage: `url(${Elephants})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Zebras.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Zebras.x * clientWidth,
                  y: module14.rewards.Zebras.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveReward27'
                  style={{ backgroundImage: `url(${Zebras})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Yeti.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Yeti.x * clientWidth,
                  y: module14.rewards.Yeti.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveYeti1'
                  style={{ backgroundImage: `url(${Yeti})`}}
                ></div>
              </Draggable>
            )}

            {module14.rewards.YetiBrown.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.YetiBrown.x * clientWidth,
                  y: module14.rewards.YetiBrown.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveYeti2'
                  style={{ backgroundImage: `url(${YetiBrown})`}}
                ></div>
              </Draggable>
            )}

            {module14.rewards.JeepBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.JeepBlue.x * clientWidth,
                  y: module14.rewards.JeepBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveBigReward1'
                  style={{ backgroundImage: `url(${JeepBlue})`, zIndex: displayGreenButton ? 2 : 0}}
                ></div>
              </Draggable>
            )}

            {module14.rewards.JeepPink.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.JeepPink.x * clientWidth,
                  y: module14.rewards.JeepPink.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveBigReward2'
                  style={{ backgroundImage: `url(${JeepPink})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Dragon.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Dragon.x * clientWidth,
                  y: module14.rewards.Dragon.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveWidthReward1'
                  style={{ backgroundImage: `url(${Dragon})` }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Pheonix.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Pheonix.x * clientWidth,
                  y: module14.rewards.Pheonix.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${Pheonix})` }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Tucan.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Tucan.x * clientWidth,
                  y: module14.rewards.Tucan.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveSmallReward1'
                  style={{ backgroundImage: `url(${Tucan})` }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Parrot.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Parrot.x * clientWidth,
                  y: module14.rewards.Parrot.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveSmallReward2'
                  style={{ backgroundImage: `url(${Parrot})` }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Horse1.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Horse1.x * clientWidth,
                  y: module14.rewards.Horse1.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${Horse1})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Horse2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Horse2.x * clientWidth,
                  y: module14.rewards.Horse2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${Horse2})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Lion.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Lion.x * clientWidth,
                  y: module14.rewards.Lion.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveAnimal1'
                  style={{ backgroundImage: `url(${Lion})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Cheetah.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Cheetah.x * clientWidth,
                  y: module14.rewards.Cheetah.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveAnimal2'
                  style={{ backgroundImage: `url(${Cheetah})`, zIndex: displayGreenButton ? 2 : 0 }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Hat1.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Hat1.x * clientWidth,
                  y: module14.rewards.Hat1.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveCharaterReward1'
                  style={{ backgroundImage: `url(${Hat1})` }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.Hat2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module14.rewards.Hat2.x * clientWidth,
                  y: module14.rewards.Hat2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveCharaterReward142'
                  style={{ backgroundImage: `url(${Hat2})` }}
                ></div>
              </Draggable>
            )}

            {module14.rewards.MedievalCastle.unlocked && 
              <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module14.rewards.MedievalCastle.x * clientWidth, y: module14.rewards.MedievalCastle.y * clientHeight}}
                onStop={(e,data)=>{onStop(1, data)}}
                ><div className='movePrize14' id="behind" style={{backgroundImage: `url(${MedievalCastle})`, zIndex: displayGreenButton ? 2 : 0}}></div></Draggable>}

            {module14.rewards.StoneSword.unlocked && 
              <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module14.rewards.StoneSword.x * clientWidth, y: module14.rewards.StoneSword.y * clientHeight}}
                onStop={(e,data)=>{onStop(2, data)}}
                ><div className='moveReward2' style={{backgroundImage: `url(${StoneSword})`}}></div></Draggable>}
          </div>
        </div>
      )}
    </>
  );
};
export default Module14World;
